<template>
  <div class="state-list-display-component">
    <div :class="className" @click="onClick">
      {{ label }}
    </div>
    <div>
      <state-list-hover-box
        v-if="showHoverbox"
        :stateAbbreviations="stateAbbreviations">
      </state-list-hover-box>
    </div>
  </div>
</template>

<script>
  import StateListHoverBox from '../utils/state-list-hoverbox.vue';

  export default {
    props: ['stateAbbreviations'],

    data: function () {
      return {
        showHoverbox: false,
        showInlineMax: 4
      };
    },

    watch: {
      // only add listeners if displayed, remove when hidden
      showHoverbox: function (val) {
        const clickoutListener = this.clickoutListener;
        const escListener = this.escListener;
        if (val) {
          document.body.addEventListener('click', clickoutListener);
          document.addEventListener('keydown', escListener);
        } else {
          document.body.removeEventListener('click', clickoutListener);
          document.body.removeEventListener('keydown', escListener);
        }
      }
    },

    computed: {
      className: function () {
        return this.stateAbbreviations.length > this.showInlineMax ? 'linky' : '';
      },

      // display the number of states, or the single state abbreviation
      label: function () {
        const length = this.stateAbbreviations.length;
        if (!length) {
          // show blank if no states
          return '';
        } else if (length <= this.showInlineMax) {
          // show list if $showInlineMax or fewer states
          return this.stateAbbreviations.map(abbr => abbr.id).join(' | ');
        } else {
          return `${length}`;
        }
      }
    },

    methods: {
      onClick () {
        // toggle show but only if length > $showInlineMax
        this.showHoverbox = (this.stateAbbreviations.length > this.showInlineMax) && !this.showHoverbox;
      },

      // close hoverbox
      close () {
        this.showHoverbox = false;
      },

      // close hoverbox on clickout
      clickoutListener: function (event) {
        // close hoverbox if click was outside the el and children
        if (!(this.$el == event.target || this.$el.contains(event.target))) {
          this.close();
        }
      },

      // close hoverbox on esc
      escListener: function (event) {
        if (event.keyCode == 27) {
          this.close();
        }
      }
    },
    components: {
      StateListHoverBox
    }
  };
</script>

<style>
  /*style like hyperlink and show count if > showInlineMax state*/
  .linky {
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
</style>
